import { AppThunk } from '../../../../../store/types';
import { setMainViewMode } from '../../../../../store/general/actions';
import { getLibraryGroupId, isLoggedUser } from '../../../../../store/general/selectors';
import { EMainViewMode } from '../../../../../store/general/types';
import { Navigator } from '../../../../../effects/navigator';
import { ContentLibActions } from '../../../../../store/contentLib/actions';
import { EContentLibViewMode } from '../../../../../store/contentLib/types';
import { SaveVideoConfirmManager } from '../../../../../effects/saveVideoConfirmManager';
import { LoginPopupActions } from '../../../../../store/loginPopup/actions';

export class PlaylistEvents {

	public static onClick (
	): AppThunk {
		return (
			dispatch,
			getState,
		) => {
			const groupId = getLibraryGroupId(getState()) || 0;
			Navigator.openMyStuff();
			dispatch(setMainViewMode(EMainViewMode.MY_LIBRARY));
			dispatch(ContentLibActions.setViewMode(EContentLibViewMode.GROUP_VIDEO_LIST));
			dispatch(ContentLibActions.setSelectedGroupId(groupId));
		}
	}


	public static onSave (
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			if (!isLoggedUser(getState())) {
				return dispatch(LoginPopupActions.set({
					show: true,
					text: 'Please login to add videos to your playlist'
				}));
			}
			SaveVideoConfirmManager.saveToMyStuff();
		}
	}

}